import {resolveBackground} from '#core/utils/color-utils.js';

export function bettingCenterFactory(PALETTE) {
    const BASE_BUTTON = {
        padding: '0 8px',
        height: '40px', // important to have height here since height 100% doesn't work on some elements (such as betslip tabs)
        alignItems: 'center',
        whiteSpace: 'nowrap', // only Solverde have long PT translation here
    };

    return {
        BettingCenterView: {
            tabs: {
                container: {
                    style: {
                        minHeight: '100%',
                    },
                },
                tabButtons: {
                    container: {
                        style: {
                            _desktop_alignItems: 'center',
                        },
                    },
                    selectableButton: {
                        selected: {
                            style: {
                                base: {
                                    ...BASE_BUTTON,
                                    ...PALETTE.BETTING_CENTER_TAB_BUTTON_SELECTED_TEXT,
                                    ...resolveBackground(PALETTE.BETTING_CENTER_TAB_BUTTON_SELECTED_BG),
                                },
                            },
                        },
                        unselected: {
                            style: {
                                base: {
                                    ...BASE_BUTTON,
                                    ...PALETTE.BETTING_CENTER_TAB_BUTTON_TEXT,
                                    ...resolveBackground(PALETTE.BETTING_CENTER_TAB_BUTTON_BG),
                                },
                            },
                        },
                        indicator: {
                            style: {
                                base: {
                                    height: 0,
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                },
            },
            container: {
                style: PALETTE.BETTING_CENTER_SHOW_BOX_SHADOW
                    ? {_desktop_boxShadow: PALETTE.BETTING_CENTER_BOX_SHADOW}
                    : {},
            },
        },
    };
}
